import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar} from 'shared/components';

const QualificationStatusChangeEntry = ({entry}) => {
  const user = entry.automated ? {} : entry.user;

  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={user} collageAvatar={entry.automated} size='sm'/>
      <div>
        <div className='flex items-center gap-2'>
          <div className='h3 medium'>
            <FormattedMessage id={entry.isDisqualified ? 'recruiting.hiring_funnel.Disqualified' : 'recruiting.hiring_funnel.Qualified' }/>
          </div>
          <div className='h5 jumbo'>{entry.date}</div>
        </div>
        <div className='h5 jumbo'>
          {entry.automated ?
            <FormattedMessage id='recruiting.hiring_funnel.Automatically disqualified based on rules'/> :
            entry.name
          }
        </div>
      </div>
    </div>
  );
};

export default observer(QualificationStatusChangeEntry);
